<template>
  <div>
    <button :title="data_title" class="btnCustom btnCustom__confirm btnCustom-md">
      {{ data_name }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'SaveButton',
  props: {
    title: {
      type: String,
    },
    name: {
      type: String,
    },
  },
  data: function () {
    return {
      data_title: this.$t('save'),
      data_name: this.$t('save'),
    };
  },
  mounted: function () {
    this.setData();
  },
  methods: {
    setData: function () {
      if (this.title !== undefined && this.title !== null) this.data_title = this.title;
      if (this.name !== undefined && this.name !== null) this.data_name = this.name;
    },
  },
};
</script>

<style scoped></style>
